import { useContext, createContext } from "react";
export const useTableContext = () => {
    const context = useContext(TableContext);
    if (context === undefined) {
        throw new Error("A component has been used outside of the Provider components");
    }
    return context;
};
export const TableContext = createContext(undefined);
